import { useState, useEffect } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { MdOutlineCancelScheduleSend } from "react-icons/md";
import PropTypes from 'prop-types';

const OnCancelConfirm = ({ onConfirm, disabled, title, subtitle, actionTitle }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    const options = {
        title: t('modal.cancel.title'),
        subtitle: t('modal.cancel.subtitle'),
        negativeAction: t('modal.cancel.negative_action'),
        positiveAction: t('modal.cancel.positive_action'),
    }


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize font-bold text-lg  focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
                rounded p-2  ${disabled && ' text-gray-400 '}`}
                onClick={() => setIsOpen(true)}>
                {actionTitle} <MdOutlineCancelScheduleSend />
            </button>
            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
            >
                <div className="flex h-full flex-col  text-center justify-between items-center ">
                    <div className="bg-red-100 p-4 rounded-full">
                        <MdOutlineCancelScheduleSend className="text-red-500 text-3xl" />
                    </div>

                    <p className="text-gray-800  text-xl font-bold mt-4">
                        {options.title}
                    </p>
                    <p className="text-gray-600 text-sm py-2 px-6">
                        {options.subtitle}
                    </p>
                    <div className="flex items-center justify-center w-full mt-8">

                        <button className="capitalize shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-700 transition duration-150 ease-in-out hover:bg-red-600 bg-red-500 rounded text-white px-8 py-2 text-sm "
                            onClick={() => {
                                setIsOpen(false)
                                onConfirm();
                            }}
                        >   {t('actions.confirm')}
                        </button>
                        <button className="capitalize shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  focus:ring-gray-400  bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm ml-3"
                            onClick={() => setIsOpen(false)}
                        >   {t('actions.cancel')}
                        </button>



                    </div>

                </div>
            </ModalWrapper>

        </>

    );

}

OnCancelConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actionTitle: PropTypes.node,
};

export default OnCancelConfirm;


